export const USER_ORDER_STATUS = {
  COMPLETED: 3,
};

export const USER_DISPUTE_STATUS = {
  RAISED: 0,
};
